import { startOfDay } from 'date-fns';
import { z } from 'zod';

export const promoDateRangeFields = {
  validFrom: z.string().min(1, { message: 'Start date is required' }),
  validUntil: z.string().min(1, { message: 'End date is required' }),
};

export function refinePromoDateRange(value: {
  validFrom: string;
  validUntil: string;
}): boolean {
  return (
    startOfDay(new Date(value.validFrom)) <=
    startOfDay(new Date(value.validUntil))
  );
}

export const promoDateRangeError = {
  path: ['validUntil'] as (string | number)[],
  message: 'End date must be on or after start date',
};
